import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Cuándo recibo el recetario?',
    answer: '👉 Al instante. Apenas confirmás la compra, lo recibís en tu email con acceso inmediato. Podés empezar hoy mismo… sin esperar nada.'
  }, {
    question: '¿Cómo accedo al contenido?',
    answer: 'Recibís un archivo digital (PDF) que podés abrir desde tu celular, tablet o computadora. 👉 Literalmente hacés clic y ya tenés todas tus comidas resueltas.'
  }, {
    question: '¿Esto es solo un recetario más?',
    answer: 'No. 👉 Es un sistema para dejar de pensar qué comer todos los días. No está hecho para inspirarte… Está hecho para que lo uses en tu vida real, incluso cuando no tenés tiempo ni ganas.'
  }, {
    question: '¿Necesito saber cocinar?',
    answer: 'Para nada. Las recetas están pensadas para ser: simples, rápidas, fáciles de seguir. 👉 Aunque no tengas experiencia, podés hacerlo sin problema.'
  }, {
    question: '¿Voy a tener que usar ingredientes raros o difíciles?',
    answer: 'No. Todo está pensado con ingredientes simples, fáciles de conseguir y reales. 👉 Nada complicado. Nada gourmet. Todo aplicable.'
  }, {
    question: '¿Y si empiezo motivada pero después lo dejo?',
    answer: 'Justamente esto está diseñado para evitar eso. 👉 Tenés tantas opciones simples y ricas que siempre vas a tener algo para elegir, sin caer en lo de siempre.'
  }, {
    question: '¿Qué pasa si no es lo que esperaba?',
    answer: 'Tu compra es segura. 👉 Si no te ayuda a resolver tus comidas o sentís que no es para vos, te devolvemos el dinero. Tenés 7 días de garantía total.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal" data-id="element-46">
            🔥 PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-xl overflow-hidden bg-background" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex justify-between items-center p-6 text-left focus:outline-none" data-id="element-49">
                <span className="font-bold text-lg text-charcoal pr-4" data-id="element-50">
                  {faq.question}
                </span>
                <ChevronDown className={`flex-shrink-0 text-primary transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-51" />
              </button>
              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-53">
                    <div className="p-6 pt-0 text-gray-700 leading-relaxed border-t border-gray-100 mt-2" data-id="element-54">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}